// @flow

import * as React from 'react';

import { useTranslator } from '@gandi/translate';
import { Alert } from '@gandi/ui';

import type { AlteredSearchChange } from '../types';

export type Props = {
  change: AlteredSearchChange,
  withBackground?: boolean,
};

export default function AlteredSearchWarning({
  change,
  withBackground,
}: Props): React.MixedElement {
  const { __ } = useTranslator();

  const alertProps = React.useMemo(
    () => ({
      label_too_long: {
        message: __(
          'A domain label must contain a minimum of 1 character and a maximum of 63 characters. Please use a name that you can memorize, type, spell, and share easily.',
        ),
        intent: 'warning',
      },
      idna_compatibility: {
        message: __(
          'Some characters or symbols you used will not be accepted or parsed correctly as a domain address in browsers. We then suggest relevant names for your project.',
        ),
        intent: 'info',
      },
      invalid_punctuation: {
        message: __(
          'Some characters or symbols you used will not be accepted or parsed correctly as a domain address in browsers. We then suggest relevant names for your project.',
        ),
        intent: 'info',
      },
    }),
    [__],
  );

  return (
    <Alert
      className="wrapper-md"
      {...alertProps[change.code]}
      marginTop="base"
      marginBottom="small"
      withBackground={withBackground}
    />
  );
}
